export default __webpack_public_path__ + "977c6b6629bcd9c061367316374b23ae.svg";